import React, { useState, useEffect } from 'react'
import {
  checkUserNames,
  checkUserMobiles,
  addSubUsersBatchNormal,
  addSubUsersBatch,
} from '@vt/apis/lib-ex/v2/users'
import { getQuery } from '@vt/utils'
import { Toast, Button } from '@ow/comps'
import { newLoginTypeTpls } from '@vt/apis/lib-ex'
import AddTips from './components/AddTips'
import InputUser from './components/subAccount/InputUser'
import SelAddType from './components/subAccount/AddType'
import UploadUser from './components/subAccount/UploadUser'
import DataInfo from './components/subAccount/DataInfo'
import UserTable from './components/subAccount/UserTable'
import AddUserOperate from './components/AddUserOperate'

const AddSubAccount = function ({
  appId,
  currentOrg,
  useOrgApi,
  orgId,
  usersMutate,
  closeModal,
}) {
  // 添加用户所属组织
  const [selectOrgId, setSelectOrgId] = useState(orgId)
  // 用户角色
  const [selectRole, setSelectRole] = useState(null)
  // 当前渲染的组件
  const [currentComponent, setCurrentComponent] = useState()
  const [users, setUsers] = useState([])
  // 选择的用户
  const [checkedItems, setCheckedItems] = useState([])
  const [isUsersCheckedPass, setIsUsersCheckedPass] = useState(false)
  // 已存在的用户名、手机号
  const [existNames, setExistNames] = useState([])
  const [existMobiles, setExistMobiles] = useState([])
  const [wrongNum, setWrongNum] = useState(0)

  const { tpl } = getQuery()

  // 校验相关
  // 校验用户名是否存在
  const checkIsNamesExist = (names) => {
    checkUserNames(appId, names).then((data) => {
      setExistNames(data)
      setCurrentComponent('table')
    })
  }

  // 校验手机号是否存在
  const checkIsMobileExist = (mobiles, paramOrgId) => {
    checkUserMobiles(appId, mobiles, paramOrgId).then((data) => {
      if (data.find((x) => x[mobiles])) {
        setIsUsersCheckedPass(false)
      }
      setExistMobiles(data)
      setCurrentComponent('table')
    })
  }

  useEffect(() => {
    checkIsNamesExist(
      users.map((v) => {
        return v.username
      })
    )
  }, [users])

  useEffect(() => {
    if (selectOrgId) {
      const arr = users.map((v) => {
        return v.mobile
      })

      checkIsMobileExist(arr, selectOrgId)
    }
  }, [users, selectOrgId])

  const updateMyData = (rowIndex, columnId, value) => {
    if (columnId) {
      setUsers((old) => {
        return old.map((row, index) => {
          if (index === rowIndex) {
            return {
              ...old[rowIndex],
              [columnId]: value,
            }
          }
          return row
        })
      })
    } else if (rowIndex === -1) {
      setUsers((old) => {
        const indexs = (checkedItems || []).map((v) => {
          return v.index
        })
        const data = old.filter((row) => {
          return indexs.indexOf(row.index) < 0
        })
        return data.map((v, index) => {
          return { ...v, index }
        })
      })
    } else {
      setUsers((old) => {
        const data = old.filter((row, index) => {
          return index !== rowIndex
        })
        return data.map((v, index) => {
          return { ...v, index }
        })
      })
    }
  }
  // 处理用户添加成功后操作
  const handleAddUserSucc = () => {
    Toast.success({
      title: '通知',
      description: '添加成功！',
    })
    setUsers([])
    setCurrentComponent()
    usersMutate()
    closeModal()
    setSelectRole(null)
  }
  const onClickAdd = async () => {
    const data = (
      checkedItems.length && checkedItems.length > 0 ? checkedItems : users
    ).map((obj) => {
      return {
        username: obj.username,
        name: obj.name,
        password: obj.password,
        orgId: selectOrgId || currentOrg.key,
        roleId: selectRole,
        mobile: obj.mobile,
        loginName: obj.username,
        appId,
      }
    })
    // 因为新上的【人员管理】相关接口暂时只适用于内蒙古项目/移动视频巡检/朝阳环境检查，所以单独处理
    if (newLoginTypeTpls.includes(tpl)) {
      // if (
      //   tpl === 'zrzh' ||
      //   tpl === 'ydspxj' ||
      //   tpl === 'cyhjjc' ||
      //   tpl === 'nydl'
      // ) {
      await addSubUsersBatchNormal(appId, data)
      handleAddUserSucc()
    } else {
      await addSubUsersBatch(appId, data)
      handleAddUserSucc()
    }
  }

  // 是否渲染选择添加类型的视图
  const isShowAddType =
    currentComponent !== 'text' &&
    currentComponent !== 'table' &&
    currentComponent !== 'excel'
  // 是否渲染添加tips提示
  const isShowTips = currentComponent === 'text' || currentComponent === 'table'
  return (
    <div className="w-full h-full">
      {isShowAddType && (
        <SelAddType
          updateAddType={(v) => {
            setCurrentComponent(v)
          }}
        />
      )}
      {isShowTips && <AddTips isTable={currentComponent === 'table'} />}
      {currentComponent === 'excel' && (
        <UploadUser
          appId={appId}
          uppyId="subAccount"
          gotoBack={setCurrentComponent}
          uploadDone={(data) => {
            setUsers(data)
          }}
        />
      )}
      {currentComponent === 'text' && (
        <InputUser
          inputDone={(data) => {
            setUsers(data)
          }}
          gotoBack={setCurrentComponent}
        />
      )}
      {currentComponent === 'table' && (
        <>
          <DataInfo
            checkedItems={checkedItems}
            users={users}
            wrongNum={wrongNum}
            onClickDelete={() => {
              updateMyData(-1)
            }}
          />
          <UserTable
            data={users}
            userNames={(users || []).map((v) => {
              return v.username
            })}
            existNames={existNames}
            existMobiles={existMobiles}
            updateMyData={updateMyData}
            updateCheckedUser={(objs) => {
              setCheckedItems(objs)
            }}
            updateAddPower={(allow) => {
              setIsUsersCheckedPass(allow)
            }}
            updateWrongNum={(v) => {
              setWrongNum(v)
            }}
            resetData={() => {
              setCurrentComponent()
            }}
            mobiles={(users || []).map((v) => {
              return v.mobile
            })}
          />
          <div className="flex flex-wrap flex-row items-center justify-between mt-2">
            <AddUserOperate
              org={currentOrg}
              useOrgApi={useOrgApi}
              updateSelRole={(v) => {
                setSelectRole(v ? v.value : null)
              }}
              isAddAbled={!(selectRole && isUsersCheckedPass)}
              updateCurrentOrgId={(v) => {
                setSelectOrgId(v)
              }}
            />
            <div className="flex items-center">
              <Button
                disabled={
                  !(
                    (currentOrg || selectOrgId) &&
                    selectRole &&
                    isUsersCheckedPass
                  )
                }
                onClick={onClickAdd}
                className="mr-2"
                type="primary"
              >
                添加
              </Button>
              <Button
                stroke
                onClick={() => {
                  setCurrentComponent()
                  setSelectRole(null)
                }}
              >
                取消
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default AddSubAccount
